import { isMobileUserAgent } from '@moonpig/web-core-utils'

export const getDeviceType = (serverSideAgent: string | null = null) => {
  return isMobileUserAgent(
    serverSideAgent !== null ? serverSideAgent : undefined,
  )
    ? 'MOBILE WEB'
    : 'WEB'
}
